import { useEffect, useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../base/customHooks/componentHOC'
import { translate } from '../../../../base/localization'
import InputCampaign from '../../../../components/InputCampaign'
import IPButton from '../../../../components/IPButton'
import IPInput from '../../../../components/IPInput'
import IPSelectBox from '../../../../components/IPSelectBox'
import Table from '../../../../components/Table'
import Translations from '../../../../translations'
import { GetBrandListApi } from '../../../Homepage/services/getBrandListApi'
import { DealerForPagePathRequest, DealerForPageMailPathResponse, PathOptions } from './models'
import { DealerForPagePathFromMailService } from './services'
import { GetMenusApi } from '../../../../layouts/components/client/services/getMenusApi'
import { exportToXLSX } from '../../../../base/utils/dataHelper'
import moment from 'moment'

interface IMenu {
  Link: string
  Id: number
  ParentId: number
  Enabled: boolean
  CompanyId: number
  CategoryId: number
  Title: string
  Order: number
  Items: IMenu[]
  isOpen?: boolean
}

function Index(props: BaseComponentWithContextProps) {
  const [pages, setPages] = useState<DealerForPageMailPathResponse[]>([])
  const [selectedPageFilter, setSelectedPageFilter] = useState<any>()
  const [selectedBrand, setSelectedBrand] = useState<any>()
  const [brands, setBrands] = useState<any>([])
  // const [filteredList, setFilteredList] = useState<DealerForPagePathResponse[]>([])
  const [searchWord, setSearchWord] = useState('')

  const [menus, setMenus] = useState<IMenu[]>([])
  //Kategori Seviyeleri
  const [level1Options, setLevel1Options] = useState<any>([])
  const [level2Options, setLevel2Options] = useState<any>([])
  const [level3Options, setLevel3Options] = useState<any>([])
  const [level4Options, setLevel4Options] = useState<any>([])
  const [selectedLevel1, setSelectedLevel1] = useState<any>()
  const [selectedLevel2, setSelectedLevel2] = useState<any>()
  const [selectedLevel3, setSelectedLevel3] = useState<any>()
  const [selectedLevel4, setSelectedLevel4] = useState<any>()
  const [selectedCategoryId, setSelectedCategoryId] = useState(null)

  //#region Tarih ve saat ayarları
  const t = translate(Translations)
  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState(new Date())
  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(' ', 'T')
  }
  const dateToISO = date => new Date(new Date(date).getTime() + 3 * 3600 * 1000).toISOString()
  //#endregion

  const [pathOptions, setPathOptions] = useState<PathOptions>({
    StartDate: startDate,
    EndDate: endDate,
    PagePath: '',
    DealerCode: '',
  })
  function updatePathOptions(prop, val) {
    setPathOptions(prev => ({ ...prev, [prop]: val }))
  }

  //#region Get data Methods
  async function DealerForPagePath(e) {
    e.preventDefault()
    const req: DealerForPagePathRequest = {
      DateRange: {
        StartDate: dateToISO(pathOptions.StartDate),
        EndDate: dateToISO(pathOptions.EndDate),
      },
      DealerCode: pathOptions.DealerCode,
      PagePath: pathOptions.PagePath,
      Filters: {
        searchWord: searchWord || undefined,
        selectedPageFilter: selectedPageFilter ? selectedPageFilter.value : undefined,
        selectedBrand: selectedBrand ? selectedBrand.label : undefined,
        categoryId: selectedCategoryId || undefined,
      },
    }
    props.showLoading()
    await new DealerForPagePathFromMailService({})
      .DealerForPagePathFromMailSource(req)
      .then(async result => {
        if (result) {
          setPages(result)
          // setFilteredList(result)
          // setShowFilterRow(true)
        }
        props.hideLoading()
      })
      .catch((err: any) => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  const handleDetail = data => {
    let rows = ''
    if (!data) {
      Swal.fire({
        title: 'Hata',
        icon: 'error',
        html: `<div>
        <div style="display: flex; justify-content: center; margin-bottom: 1rem; font-size: 16px;">
          <b>Veri bulunamadı.</b>
        </div>
      </div>`,
        backdrop: true,
        confirmButtonText: 'KAPAT',
        confirmButtonColor: '#333',
      })
      return
    }
    // data = data.sort((a, b) => Number(b.Count) - Number(a.Count))
    // const newData = data
    // let kontrol = false;
    // let sayi = 0;
    // let values = [""];

    // data.length > 0 &&
    //   data.forEach(x => {
    //     newData.forEach((a => {
    //       if (a.DealerCode === x.DealerCode) {
    //         sayi++
    //         if (sayi > 1 && values.find(element => element === x.DealerCode))
    //           kontrol = true;
    //     } }))

    //       if (!kontrol) {
    //         rows += `<div style="display: flex; margin-bottom: 0.5rem;">
    //        <div style="width: 150px; text-align: left;">${x.Count}</div>
    //        <div>${x.DealerCode}</div>
    //       </div>`
    //         values.push(x.DealerCode)
    //       }
    //     kontrol = false;
    //     sayi = 0;
    //     }
    //   )

    data = data.sort((a, b) => Number(b.Count) - Number(a.Count))
    const uniqueData = new Set()
    const counter = {}
    const filteredData = data.filter(item => {
      if (uniqueData.has(item.DealerCode)) {
        counter[item.DealerCode]++
        return false
      }
      counter[item.DealerCode] = 1
      return uniqueData.add(item.DealerCode)
    })

    filteredData.length > 0 &&
      filteredData.forEach(x => {
        rows += `<div style="display: flex; margin-bottom: 0.5rem;">
          <div style="width:150px; text-align: left;">${x.Count}</div>
          <div style="width:200px; text-align: left;">${x.DealerCode}</div>
          <div style="width:150px; text-align: center;">${counter[x.DealerCode]}</div>
        </div>`
      })

    Swal.fire({
      title: 'Detay',
      icon: 'info',
      width: 'auto',
      html: `<div>
        <div style="display: flex; margin-bottom: 1rem; font-size: 16px;">
          <b style="width:150px; text-align: left;">Ziyaret Sayısı</b>
          <b style="width:200px; text-align: left;">Ziyaret Eden Bayiler</b>
          <b style="width:150px; text-align: right;">Kullanıcı Sayısı</b>
        </div>
        ${rows}
      </div>`,
      backdrop: true,
      confirmButtonText: 'KAPAT',
      confirmButtonColor: '#333',
    })
  }

  const getMenus = () => {
    const api = new GetMenusApi({})
    api.getMenus().then((res: IMenu[]) => {
      const formattedMenus = res.map(item => ({
        ...item,
        isOpen: false,
        Items: item.Items.map(subItem => ({
          ...subItem,
          isOpen: false,
          Items: subItem.Items.map(subItem2 => ({
            ...subItem2,
            isOpen: false,
            Items: subItem2.Items.map(subItem3 => ({
              ...subItem3,
              isOpen: false,
              Items: subItem3.Items.map(subItem4 => ({
                ...subItem4,
                isOpen: false,
              })),
            })),
          })),
        })),
      }))
      setMenus(formattedMenus)
      setLevel1Options(formattedMenus.map(item => ({ value: item.Id, label: item.Title })))
    })
  }

  const getBrands = async () => {
    const getBrands = new GetBrandListApi({})
    const brand = await getBrands.getBrandList()
    const formattedBrands = brand.map(b => ({ value: b.Id, label: b.Name }))
    setBrands(formattedBrands)
  }
  //#endregion

  //#region Filter useEffects

  //#region Kategori useEffect'leri

  // Get menus on mount
  useEffect(() => {
    getMenus()
  }, [])

  // Update Level 2 options based on Level 1
  useEffect(() => {
    if (selectedLevel1) {
      const level1Item = menus.find(item => item.Id === selectedLevel1.value)
      if (level1Item) {
        setLevel2Options(level1Item.Items.map(item => ({ value: item.Id, label: item.Title })))
      } else {
        setLevel2Options([])
      }
      // Reset lower levels when a higher level is changed
      setSelectedLevel2(null)
      setSelectedLevel3(null)
      setSelectedLevel4(null)
    } else {
      setLevel2Options([])
      setSelectedLevel2(null)
      setSelectedLevel3(null)
      setSelectedLevel4(null)
    }
  }, [selectedLevel1, menus])

  // Update Level 3 options based on Level 2
  useEffect(() => {
    if (selectedLevel2) {
      const level1Item = menus.find(item => item.Id === selectedLevel1.value)
      if (level1Item) {
        const level2Item = level1Item.Items.find(item => item.Id === selectedLevel2.value)
        if (level2Item) {
          setLevel3Options(level2Item.Items.map(item => ({ value: item.Id, label: item.Title })))
        } else {
          setLevel3Options([])
        }
      } else {
        setLevel3Options([])
      }
      // Reset lower levels
      setSelectedLevel3(null)
      setSelectedLevel4(null)
    } else {
      setLevel3Options([])
      setSelectedLevel3(null)
      setSelectedLevel4(null)
    }
  }, [selectedLevel2, selectedLevel1, menus])

  // Update Level 4 options based on Level 3
  useEffect(() => {
    if (selectedLevel3) {
      const level1Item = menus.find(item => item.Id === selectedLevel1.value)
      if (level1Item) {
        const level2Item = level1Item.Items.find(item => item.Id === selectedLevel2.value)
        if (level2Item) {
          const level3Item = level2Item.Items.find(item => item.Id === selectedLevel3.value)
          if (level3Item) {
            setLevel4Options(level3Item.Items.map(item => ({ value: item.Id, label: item.Title })))
          } else {
            setLevel4Options([])
          }
        } else {
          setLevel4Options([])
        }
      } else {
        setLevel4Options([])
      }
      // Reset Level 4 selection
      setSelectedLevel4(null)
    } else {
      setLevel4Options([])
      setSelectedLevel4(null)
    }
  }, [selectedLevel3, selectedLevel2, selectedLevel1, menus])

  // Compute the final categoryId based on the most specific selection
  useEffect(() => {
    // The most specific selection available will be used:
    // Level4 > Level3 > Level2 > Level1
    const categoryId =
      selectedLevel4?.value || selectedLevel3?.value || selectedLevel2?.value || selectedLevel1?.value || null
    setSelectedCategoryId(categoryId)
  }, [selectedLevel1, selectedLevel2, selectedLevel3, selectedLevel4])

  //#endregion

  useEffect(() => {
    if (!brands.length) {
      getBrands()
    }
  }, [brands])

  // Clear other filters when one of the level filters is selected
  useEffect(() => {
    if (selectedLevel1 || selectedLevel2 || selectedLevel3 || selectedLevel4) {
      setSearchWord('')
      setSelectedPageFilter(null)
      setSelectedBrand(null)
    }
  }, [selectedLevel1, selectedLevel2, selectedLevel3, selectedLevel4])

  // Clear level filters when another filter is selected
  useEffect(() => {
    if (selectedPageFilter) {
      setSearchWord('')
      setSelectedBrand(null)
      setSelectedLevel1(null)
      setSelectedLevel2(null)
      setSelectedLevel3(null)
      setSelectedLevel4(null)
    }
  }, [selectedPageFilter])

  useEffect(() => {
    if (selectedBrand) {
      setSearchWord('')
      setSelectedPageFilter(null)
      setSelectedLevel1(null)
      setSelectedLevel2(null)
      setSelectedLevel3(null)
      setSelectedLevel4(null)
    }
  }, [selectedBrand])

  useEffect(() => {
    if (searchWord) {
      setSelectedPageFilter(null)
      setSelectedBrand(null)
      setSelectedLevel1(null)
      setSelectedLevel2(null)
      setSelectedLevel3(null)
      setSelectedLevel4(null)
    }
  }, [searchWord])
  //#endregion

  const columns = useMemo(
    () => [
      {
        Header: () => null,
        accessor: 'DealerDetails',
        width: 50,
      },
      {
        Header: 'Sıra',
        accessor: 'Index',
      },
      {
        Header: 'Sayfa Url',
        accessor: 'Path',
        width: 550,
      },
      {
        Header: 'Toplam Tıklanma',
        accessor: 'Total',
      },
      {
        Header: 'Kullanıcı Sayısı',
        accessor: 'TotalUserIds',
      },
      {
        Header: 'Bayi Sayısı',
        accessor: 'DealerCount',
      },
    ],
    []
  )

  // const data = useMemo(
  //   () =>
  //     pages.map((p, index) => {
  //       return {
  //         DealerDetails: (
  //           <div className='d-flex justify-content-center align-items-center h-100'>
  //             <i className='icon-info cursor-pointer' onClick={() => handleDetail(p.DealerDetails)}></i>
  //           </div>
  //         ),
  //         Index: index + 1,
  //         Path: p.Path,
  //         Total: p.Total,
  //         TotalUserIds: p.TotalUserIds,
  //         DealerCount: p.DealerCount,
  //       }
  //     }),
  //   [pages]
  // )
  const data = useMemo(
    () =>
      pages
        .slice() // create a copy so we don't mutate the original array
        .sort((a, b) => b.Total - a.Total)
        .map((p, index) => ({
          DealerDetails: (
            <div className='d-flex justify-content-center align-items-center h-100'>
              <i className='icon-info cursor-pointer' onClick={() => handleDetail(p.DealerDetails)}></i>
            </div>
          ),
          Index: index + 1,
          Path: p.Path,
          Total: p.Total,
          TotalUserIds: p.TotalUserIds,
          DealerCount: p.DealerCount,
        })),
    [pages]
  )

  const mainPages = [
    {
      value: '/myspecial/ssh/SerialNumberCheck?utm_source=email&utm_medium=mailing&utm_campaign=order_notification',
      label: 'Seri No Kontrolü',
    },
    {
      value: '/myspecial/myorders?utm_source=email&utm_medium=mailing&utm_campaign=order_notification',
      label: 'Siparişlerim',
    },
    { value: '/homepage', label: 'Anasayfa' },
    { value: '/myspecial', label: 'Bana Özel' },
    { value: '/myspecial/mypayments', label: 'Ödemelerim' },
    { value: '/mycard', label: 'Sepet' },
    { value: '/netChannel?page=report', label: 'Net Channel Ana Sayfa' },
    { value: '/myspecial/creditCardRates', label: 'Ödeme Oranları' },
    { value: '/openbox', label: 'AÇBOX' },
    { value: '/dpp', label: 'DPP' },
    { value: '/microsoft', label: 'Microsoft Sayfası' },
    { value: '/sss', label: 'Sık Sorulan Sorular' },
    { value: '/products?brand=HP', label: 'HP Marka Logosu' },
    { value: '/oneConfig', label: 'HP Ürün Kataloğu' },
    { value: '/myspecial/reports/open-invoices', label: 'Açık Faturalar' },
    { value: '/myspecial/ssh/WarrantyTracking', label: 'Garanti Takip' },
    { value: '/financial-information/bank-account-numbers', label: 'Banka Hesap Numaraları' },
    { value: '/myspecial/currentAccount/extract', label: 'Cari Hesap Özeti' },
    { value: '/myspecial/ssh/FaultTracking', label: 'Arıza Takibi' },
    { value: '/myspecial/creditCardOperations', label: 'Kredi Kartı Hareketlerim' },
  ]

  //#region Detaylı Süzme fonksiyonu
  // const filterList = () => {
  //   const filterConditions: ((item: DealerForPagePathResponse) => boolean)[] = []

  //   if (searchWord) {
  //     filterConditions.push(
  //       x => x.Path.toUpperCase().includes(searchWord.toUpperCase()) && x.Path.includes('searchKey')
  //     )
  //   } else if (selectedPageFilter) {
  //     filterConditions.push(c => c.Path === selectedPageFilter.value)
  //   } else if (selectedBrand) {
  //     filterConditions.push(c => c.Path.toUpperCase().includes(selectedBrand.label.toUpperCase()))
  //   }

  //   // Hierarchical filtering
  //   // Use the computed categoryId for hierarchical filtering
  //   if (selectedCategoryId) {
  //     filterConditions.push(item => item.Path === `/products?categoryId=${selectedCategoryId}&global-search=true`)
  //   }

  //   let filteredData: DealerForPagePathResponse[] = pages

  //   if (filterConditions.length > 0) {
  //     filteredData = filteredData.filter(item => {
  //       return filterConditions.every(condition => condition(item))
  //     })
  //   }
  //   setFilteredList(filteredData)
  // }
  //#endregion

  // External helper function to extract the relative page path
  function extractPagePath(url) {
    let inputValue = url.trim()
    let pagePath = inputValue

    // If the input contains ".com", extract the part after it.
    if (inputValue.includes('.com')) {
      const comIndex = inputValue.indexOf('.com')
      // Extract everything after ".com" (4 characters)
      pagePath = inputValue.substring(comIndex + 4)
      // Ensure it starts with a slash
      if (!pagePath.startsWith('/')) {
        pagePath = '/' + pagePath
      }
    }
    return pagePath
  }
  //#region Excel Export
  const excelButton = async () => {
    try {
      if (pages) {
        const data: any[] = []
        if (pages.length > 0) {
          pages.map((item, index) => {
            return data.push({
              Sıra: index + 1,
              'Sayfa Url': item.Path,
              'Toplam Tıklama': item.Total,
              'Kullanıcı Sayısı': item.TotalUserIds,
              'Bayi Sayısı': item.DealerCount,
            })
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Excele atılacak veri bulunmamaktadır.',
            allowOutsideClick: true,
            backdrop: true,
          })
          return
        }
        exportToXLSX(
          data,
          `(Mail) Sayfa Analizi ${moment(startDate).format('DD.MM.YYYY')} - ${moment(endDate).format('DD.MM.YYYY')}`
        )
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  const excelButtonWithDetail = async () => {
    try {
      if (pages) {
        const combinedData: any[] = []

        if (pages.length > 0) {
          for (let index = 0; index < pages.length; index++) {
            const page = pages[index]

            // Push the page row
            combinedData.push({
              Sıra: index + 1,
              'Sayfa Url': page.Path,
              'Toplam Tıklama': page.Total,
              'Kullanıcı Sayısı': page.TotalUserIds,
              'Bayi Sayısı': page.DealerCount,
              'Bayi Kodu': '', // Empty on the page row
              'Tıklanma Sayısı': '', // Empty on the page row
            })

            if (page.DealerDetails) {
              // Ensure dealerDetails is an array
              const dealerDetails = Array.isArray(page.DealerDetails) ? page.DealerDetails : [page.DealerDetails]

              if (dealerDetails.length > 0) {
                for (let j = 0; j < dealerDetails.length; j++) {
                  const detail = dealerDetails[j]
                  combinedData.push({
                    Sıra: '', // Leave blank for detail rows
                    'Sayfa Url': '', // Leave blank for detail rows
                    'Toplam Tıklama': '', // Leave blank for detail rows
                    'Kullanıcı Sayısı': '', // Leave blank for detail rows
                    'Bayi Sayısı': '', // Leave blank for detail rows
                    'Bayi Kodu': detail.DealerCode,
                    'Tıklanma Sayısı': detail.Count,
                  })
                }
              }
            }
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Excele atılacak veri bulunmamaktadır.',
            allowOutsideClick: true,
            backdrop: true,
          })
          return
        }
        exportToXLSX(
          combinedData,
          `Bayi Bazlı (Mail) Sayfa Analizi ${moment(startDate).format('DD.MM.YYYY')} - ${moment(endDate).format(
            'DD.MM.YYYY'
          )}`
        )
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }
  //#endregion

  return (
    <div className=''>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <span className='h4 mb-0'>(Mail)Sayfa Analizi</span>
            <div className='d-flex align-items-center'>
              <span>Excel: </span>
              <button
                type='button'
                style={{
                  border: '1px solid #2e7d32',
                  borderRadius: 0,
                  width: '29px',
                  height: '29px',
                  backgroundColor: 'white',
                  margin: '0 10px',
                }}
                onClick={excelButton}
                className='btn text-capitalize background-white-important d-flex align-items-center'
              >
                <i
                  className='fas fa-file-excel'
                  style={{
                    marginLeft: '-6px',
                    fontSize: '18px',
                    color: '#2e7d32',
                  }}
                ></i>
              </button>
              <span>Bayi Bazlı Excel: </span>
              <button
                type='button'
                style={{
                  border: '1px solid #2e7d32',
                  borderRadius: 0,
                  width: '29px',
                  height: '29px',
                  backgroundColor: 'white',
                  margin: '0 10px',
                }}
                onClick={excelButtonWithDetail}
                className='btn text-capitalize background-white-important d-flex align-items-center'
              >
                <i
                  className='fas fa-file-excel'
                  style={{
                    marginLeft: '-6px',
                    fontSize: '18px',
                    color: '#2e7d32',
                  }}
                ></i>
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='form-group form-fg w-100'>
              <form id='form1' className='form-validate w-100' noValidate onSubmit={DealerForPagePath}>
                <div className='form-row d-flex flex-wrap'>
                  <div className='form-group col-md-2'>
                    <label>Başlangıç Tarihi</label>
                    <InputCampaign
                      type='date'
                      id='StartDate'
                      name='StartDate'
                      label=''
                      value={toDateTimeLocal(pathOptions.StartDate)}
                      onChange={e => updatePathOptions('StartDate', new Date(e.target.value))}
                      isActive
                    />
                  </div>
                  <div className='form-group col-md-2'>
                    <label>Bitiş Tarihi</label>
                    <InputCampaign
                      type='date'
                      id='EndDate'
                      name='EndDate'
                      label={''}
                      value={toDateTimeLocal(pathOptions.EndDate)}
                      onChange={e => updatePathOptions('EndDate', new Date(e.target.value))}
                      isActive
                    />
                  </div>
                  <div className='form-group col-md-2'>
                    <label>Sayfa Filtre</label>
                    <IPSelectBox
                      isClearable
                      placeholder='Sayfa'
                      options={mainPages}
                      value={selectedPageFilter}
                      onChangeSingle={option => {
                        setSelectedPageFilter(option)
                      }}
                    />
                  </div>
                  <div className='form-group col-md-2'>
                    <label>Bayi Filtre</label>
                    <IPInput
                      title='Bayi Kodu Alanı'
                      type='text'
                      id='Title'
                      className='form-control'
                      name='Title'
                      placeholder='Bayi kodu giriniz'
                      onChange={e => {
                        let code = e.target.value.trim()
                        // Remove all occurrences of "0000" from the input
                        code = code.replace(/0000/g, '')
                        updatePathOptions('DealerCode', code)
                      }}
                      value={pathOptions.DealerCode || ''}
                    />
                  </div>
                  <div className='form-group col-md-2' style={{ marginTop: "30px" }}>
                    <IPButton
                      type='submit'
                      className='btn btn-danger'
                      text={t('pages.admin.siteReports.mailSend.showButton')}
                    />
                  </div>
                  {/* 
                  // ...existing code...
                  */}
                </div>

                {/* 
                // ...existing code...
                */}
              </form>
            </div>
            <Table columns={columns} data={data} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(Index)
